import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Star } from "lucide-react";

export default function Drivers() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/drivers").then((r) => setItems(r.data || []));
  }, []);

  return (
    <div>
      <div className="flex items-end justify-between mb-5">
        <div>
          <p className="text-[11px] uppercase tracking-widest text-slate-400 font-bold">Fleet drivers</p>
          <h1 className="font-display font-bold text-3xl text-slate-900">Drivers</h1>
        </div>
        <div className="flex gap-2">
          <span className="text-xs px-3 py-1.5 rounded-full bg-emerald-50 text-emerald-700 font-bold uppercase tracking-wider">
            {items.filter(i => i.online).length} online
          </span>
          <span className="text-xs px-3 py-1.5 rounded-full bg-slate-100 text-slate-700 font-bold uppercase tracking-wider">{items.length} total</span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
        {items.map(d => (
          <div key={d.id} data-testid={`driver-card-${d.id}`} className="bg-white rounded-2xl border border-slate-200 p-4">
            <div className="flex items-start gap-3">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary to-primary-700 text-white flex items-center justify-center font-display font-bold text-lg">
                {d.name?.charAt(0)}
              </div>
              <div className="flex-1">
                <p className="font-display font-bold text-slate-900">{d.name}</p>
                <p className="text-[10px] text-slate-400 font-mono">{d.enec_id}</p>
                <div className="flex items-center gap-1 mt-1">
                  <Star size={12} className="fill-amber-400 text-amber-400" />
                  <span className="text-xs font-bold text-slate-700">{d.rating || "5.0"}</span>
                </div>
              </div>
              <span className={`text-[10px] px-2 py-0.5 rounded-full font-bold uppercase tracking-wider ${d.online ? "bg-emerald-50 text-emerald-700" : "bg-slate-100 text-slate-500"}`}>
                {d.online ? "Online" : "Offline"}
              </span>
            </div>
            {d.vehicle && (
              <div className="mt-3 pt-3 border-t border-slate-100">
                <p className="text-[10px] uppercase tracking-wider text-slate-400 font-bold">Assigned vehicle</p>
                <p className="text-sm font-semibold text-slate-900">{d.vehicle.make} {d.vehicle.model}</p>
                <p className="text-xs text-slate-500 font-mono">{d.vehicle.plate_number}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
